import { Box, BoxProps } from '@chakra-ui/react/box';
import { chakra } from '@chakra-ui/react/styled-system';
import { Text } from '@chakra-ui/react/text';

import playButton from './play_button.svg';

type VideoLinkBoxProps = {
  onClick?: () => void;
  label: string;
} & BoxProps;

const VideoLinkBox = ({ onClick, label, ...props }: VideoLinkBoxProps) => {
  return (
    <Box
      as="button"
      borderRadius="12"
      bgGradient="to-r"
      gradientFrom="#340954"
      gradientTo="color/purple/strong"
      backgroundSize="cover"
      display="flex"
      flexDirection={['row', 'column']}
      alignItems="center"
      justifyContent="center"
      paddingBlock="24"
      gap="16"
      boxShadow="elevation/md"
      transition="200ms"
      css={{
        _hover: {
          boxShadow: 'elevation/lg',
          '*': {
            opacity: 1,
          },
        },
      }}
      onClick={onClick}
      {...props}
    >
      <chakra.img alt="Start the video" src={playButton} width="48" height="48" opacity={0.8} />
      <Text textStyle="sans/size-2/bold" color="text/on-color" opacity={0.8}>
        {label}
      </Text>
    </Box>
  );
};

export default VideoLinkBox;
